import { BorderedContainer } from '../../../common/BorderedContainer';
import { convertToPresenceAbsence } from '../../../common/converters';
import { SectionTitle } from '../../../common/SectionTitle';
import { InfoDisplay } from '../../common/InfoDisplay';
import { IncidentDetailPatient } from 'sections/niigata/features/IncidentDetail/useIncidentDetailForNiigata';

type Props = {
  /** 交通事故。 */
  trafficAccident: IncidentDetailPatient['trafficAccident'];
};

/** 交通事故のコンポーネント。 */
export const TrafficAccident = ({ trafficAccident }: Props) => {
  return (
    <BorderedContainer>
      <div className="flex flex-col gap-[24px]">
        <SectionTitle text="交通事故" />
        <div className="flex flex-wrap gap-x-[40px] gap-y-[24px] xl:gap-x-[96px]">
          {trafficAccident ? (
            <>
              <InfoDisplay
                title="事故形態"
                content={
                  trafficAccident.accidentType &&
                  trafficAccident.accidentType.length > 0
                    ? trafficAccident.accidentType.join(', ')
                    : ''
                }
              />
              {renderSideInfo({
                side: trafficAccident.patientSide,
                titlePrefix: '傷病者',
              })}
              {renderSideInfo({
                side: trafficAccident.anotherSide,
                titlePrefix: '相手',
              })}
            </>
          ) : (
            <EmptyField />
          )}
        </div>
      </div>
    </BorderedContainer>
  );
};

type RenderSideInfoProps = {
  /** 事故状況。 */
  side:
    | IncidentDetailPatient['trafficAccident']['patientSide']
    | IncidentDetailPatient['trafficAccident']['anotherSide'];
  /** タイトルの接頭辞。 */
  titlePrefix: string;
};

const renderSideInfo = ({ side, titlePrefix }: RenderSideInfoProps) => (
  <>
    <InfoDisplay
      title={`${titlePrefix}側`}
      content={side ? (side.accidentSituation ?? '') : ''}
    />
    <InfoDisplay
      title={`${titlePrefix}側ヘルメット`}
      content={side ? convertToPresenceAbsence(side.onHelmet) : ''}
    />
  </>
);

const EmptyField = () => (
  <>
    <InfoDisplay title="事故形態" content="" />
    <InfoDisplay title="傷病者側" content="" />
    <InfoDisplay title="傷病者側ヘルメット" content="" />
    <InfoDisplay title="相手側" content="" />
    <InfoDisplay title="相手側ヘルメット" content="" />
  </>
);
